type syncOrAsyncFn = () => Promise<void> | void;

export class Heartbeat {
    #pingInterval: null | ReturnType<typeof setTimeout>;
    readonly #delayMs = 1000;
    readonly #enableFn: syncOrAsyncFn;
    readonly #pingFn: syncOrAsyncFn;

    constructor(funcs: { enable: syncOrAsyncFn; ping: syncOrAsyncFn }) {
        this.#enableFn = funcs.enable;
        this.#pingFn = funcs.ping;
        this.#pingInterval = null;
    }

    async start(): Promise<void> {
        await this.#enableFn();

        if (this.#pingInterval === null) {
            this.#pingInterval = setInterval(() => {
                void this.#pingFn();
            }, this.#delayMs);
        }
    }

    stop(): void {
        if (this.#pingInterval !== null) {
            clearInterval(this.#pingInterval);

            this.#pingInterval = null;
        }
    }
}
